import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { CreateProjectForm34kekzdlsbod1 as CreateProjectForm } from './CreateProjectForm.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { Type_ContractorTermsAndConditions_getInstance35f4ps0n3qx14 as Type_ContractorTermsAndConditions_getInstance } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { AgreementData1bovrwm0h7gbm as AgreementData } from '../../../utils/AgreementData.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { exportCrowPayLegalDocument31qdjr0k7gqoi as exportCrowPayLegalDocument } from '../../dialogs/emailDocumentDialog.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { html1nvxkcfsy8qu3 as html } from '../../../utils/utils.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_titlelss9nf4gv6ut as get_title } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.tji_1.sji_1.dfz($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  get_pageNavigator($this.uji_1).pd6(new (CreateProjectForm())());
  return Unit_instance;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var CreateProject$renderMainContent$slambdaClass;
function CreateProject$renderMainContent$slambda() {
  if (CreateProject$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.tji_1 = this$0;
        this.uji_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateProject$renderMainContent$slambdaClass = $;
  }
  return CreateProject$renderMainContent$slambdaClass;
}
function CreateProject$renderMainContent$slambda_0(this$0, $$this$button) {
  var i = new (CreateProject$renderMainContent$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateProject$renderMainContent$slambdaClass_0;
function CreateProject$renderMainContent$slambda_1() {
  if (CreateProject$renderMainContent$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button) {
        this.vji_1 = $$this$button;
      }
      uao($completion) {
        get_pageNavigator(this.vji_1).sd6();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateProject$renderMainContent$slambdaClass_0 = $;
  }
  return CreateProject$renderMainContent$slambdaClass_0;
}
function CreateProject$renderMainContent$slambda_2($$this$button) {
  var i = new (CreateProject$renderMainContent$slambda_1())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateProjectClass;
function CreateProject() {
  if (CreateProjectClass === VOID) {
    class $ {
      constructor() {
        this.rji_1 = MemberRole_Manager_getInstance();
        this.sji_1 = new (AgreementData())(Type_ContractorTermsAndConditions_getInstance());
      }
      dhg() {
        return this.rji_1;
      }
      thi(_this__u8e3s4) {
        var agreed = Signal().hak(false);
        var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        view_0.lbb(get_centered(view_0), title(view_0, 'Terms of Service'));
        view_0.lbb(get_centered(view_0), exportCrowPayLegalDocument(view_0, get_waitForNotNull(this.sji_1.xfy_1)));
        view.hbb(p_0, view_0);
        var tmp_0 = view.kbb(get_scrolling(view), get_expanding(view));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
        html(view_1, ($this$html) => $this$html.eaj(this.sji_1.xfy_1).b5v_1);
        view.hbb(p_1, view_1);
        view.lbb(tmp_0, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        view_3.zbm(false);
        var tmp_1 = get_centered(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Checkbox())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zah(view_4.ebk_1, agreed);
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_1, view_4);
        var tmp_2 = get_centered(view_3);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.gbb(p_5, view_5);
        view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'I agree to the terms of service as stated above.';
        var tmp_3 = view_5.vb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = value;
        }
        tmp_3.hbu(tmp_4);
        view_3.hbb(p_5, view_5);
        view_3.lbb(tmp_2, view_5);
        view.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_6 = view.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
        view.gbb(p_6, view_6);
        view_6.zbm(false);
        view_6.bb9(get_AppDimensions().kg2_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$26 = view_6.jbb(ButtonSemantic_getInstance());
        var tmp_5 = view_6.kbb(tmp$ret$26, get_primaryButton(view_6));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = Button$_get_enabled_$ref_61t7nx(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, Button$_set_enabled_$ref_o8kynz(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp$ret$27 = $this$reactiveScope.daj(agreed);
          this_0.set(tmp$ret$27);
          return Unit_instance;
        });
        specCenteredText(view_7, 'Accept Terms');
        onClick(view_7, VOID, VOID, CreateProject$renderMainContent$slambda_0(this, view_7));
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_5, view_7);
        var tmp_8 = get_textButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.gbb(p_8, view_8);
        body(view_8, 'Discard');
        onClick(view_8, VOID, VOID, CreateProject$renderMainContent$slambda_2(view_8));
        view_6.hbb(p_8, view_8);
        view_6.lbb(tmp_8, view_8);
        view.hbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Space())(view.pc(), 2.0);
        var tmp0_elvis_lhs_9 = view.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
        view.gbb(p_9, view_9);
        view.hbb(p_9, view_9);
        _this__u8e3s4.hbb(p, view);
        _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render;
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'CreateProject', CreateProject, VOID, [ContractorPage()]);
    CreateProjectClass = $;
  }
  return CreateProjectClass;
}
//region block: exports
export {
  CreateProject as CreateProject30799kzrue0ed,
};
//endregion

//# sourceMappingURL=CreateProject.mjs.map
